import { HilPresentationRequestEnvelopeReader } from '@bizfirst/hil-core';
import { useHilContext } from '../context/HilContext';
import { useHilStore } from '../store/hilStore';

export function useHilReader(): HilPresentationRequestEnvelopeReader | null {
  const active = useHilStore((s) => s.active);
  const { currentUserID } = useHilContext();

  if (!active) return null;

  try {
    return new HilPresentationRequestEnvelopeReader(active, { currentUserID });
  } catch {
    return null;
  }
}
